import THDStorageUtils, { COOKIE_STORAGE, } from '@thd-olt-global/thd-storage-utils';
import { isSsr } from './general';
export var getAuthorizationToken = function () { var _a, _b; return !isSsr ? ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.token) || '' : ''; };
export var getAuthorizationTokenJWT = function () { var _a, _b; return !isSsr ? ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.jwt) || '' : ''; };
export var getSvocId = function () { var _a, _b; return isSsr ? null : ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.svocID) || ''; };
export var getUserId = function () { var _a, _b; return isSsr ? null : ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.userID) || ''; };
export var getMemberId = function () {
    var _a, _b;
    if (isSsr)
        return null;
    var token = getAuthorizationToken();
    var svocId = getSvocId();
    if (token && svocId)
        return svocId;
    return ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.userID) || '';
};
export var isStoreFrontLoggedIn = function () {
    return (THDStorageUtils.get(COOKIE_STORAGE, { key: 'THD_STOREFRONT' }) !==
        'undefined');
};
export var isLoggedIn = function () {
    var _a, _b;
    return ((_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.isLoggedIn) || false;
};
export var getEmail = function () { var _a, _b; return (_b = (_a = window.THDCustomer) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.email; };
